<template>
  <Modal
    class="rule"
    @close="toggleModal('rule')"
    v-if="modals.rule && roles.size"
  >
    <font-awesome-icon
      @click="toggleModal('gameplay')"
      icon="balance-scale"
      class="toggle"
      title="Spielablauf-Merkblatt anzeigen"
    />
    <h3>
      Regel-Merkblatt
      <font-awesome-icon icon="balance-scale" />
    </h3>

    <dl>
        <dt>GEWINNEN UND VERLIEREN</dt>
        <dd>
            • Das <u>GUTE TEAM</u> gewinnt, sobald der Dämon tot ist.
        </dd>
        <dd>
            • Das <u>BÖSE TEAM</u> gewinnt, sobald nur noch zwei Personen (inklusive Dämon) am Leben sind.
        </dd>
        <br />
        <dt>DÄMON UND SCHERGEN</dt>
        <dd>
            • <u>Dämon und Schergen</u> wissen zu Beginn des Spiels voneinander.
            Sie kennen jedoch nicht die genau Rolle der anderen.
        </dd>
        <dd>
            • Der Dämon erhält außerdem <u>drei Bluffs</u> – Rollen, die nicht im Spiel sind.
        </dd>
        <dd>
            • Schergen erhalten keine Bluffs.
        </dd>
        <br />
        <dt>ZUSTÄNDE</dt>
        <dd>
            • Alle sind entweder <u>lebendig oder tot</u>.
        </dd>
        <dd>
            • Figuren sterben meistens tagsüber durch Exekution oder Nachts durch die Fähigkeiten anderer Charaktere.
            Auch tote Figuren können exekutiert oder nachts vom Dämon ausgewählt werden (zum Beispiel wichtig, um tagsüber den Vortox-Dämon zu befriedigen oder nachts keinen Tod zu verursachen).
        </dd>
        <dd>
            • Tote verlieren ihre Fähigkeit (außer wenn anders spezifiziert), können jedoch weiterhin mitdiskutieren und noch genau einmal im Spiel abstimmen.
        </dd>
        <dd>
            • Wer <u>betrunken oder vergiftet</u> ist, dessen Fähigkeit funktioniert nicht.
            Falls die Fähigkeit Informationen gibt, kann die Spielleitung diese trotzdem geben.
            Die Information kann in diesem Fall falsch oder richtig sein.
        </dd>
        <dd>
            • Nutzt eine betrunkene oder vergiftete Person eine „Einmal im Spiel“-Fähigkeit, so ist diese verloren, auch wenn die Figur wieder nüchtern oder gesund wird.
            Andere Fähigkeiten funktionieren nach dem nüchtern/gesund werden wieder normal.
        </dd>
        <dd>
            • <u>Besessen</u> ist, wer andere von etwas zu überzeugen versucht.
            Die Spielleitung kann eine Strafe geben, wenn Besessenheit gebrochen wird.
            Böse Spieler*innen könnten der Spielleitung davon berichten, wenn du in ihrem Beisein deine Besessenheit brichst.
        </dd>
        <br />
        <dt>WEITERE FRAGEN?</dt>
        <dd>
            • Regelfragen können jederzeit gestellt werden.
            Die Spielleitung beantwortet diese wahrheitsgemäß, aber verrät dabei niemals die Rollen von Mitspielenden.
            Falls anders nicht möglich können Fragen auch im privaten Gespräch mit der Spielleitung geklärt werden.
        </dd>
    </dl>

  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal
  },
  computed: {
    /**
     * Return a list of jinxes in the form of role IDs and a reason
     * @returns {*[]} [{first, second, reason}]
     */
    jinxed: function() {
      const jinxed = [];
      this.roles.forEach(role => {
        if (this.jinxes.get(role.id)) {
          this.jinxes.get(role.id).forEach((reason, second) => {
            if (this.roles.get(second)) {
              jinxed.push({
                first: role,
                second: this.roles.get(second),
                reason
              });
            }
          });
        }
      });
      return jinxed;
    },
    rolesGrouped: function() {
      const rolesGrouped = {};
      this.roles.forEach(role => {
        if (!rolesGrouped[role.team]) {
          rolesGrouped[role.team] = [];
        }
        rolesGrouped[role.team].push(role);
      });
      delete rolesGrouped["traveler"];
      return rolesGrouped;
    },
    playersByRole: function() {
      const players = {};
      this.players.forEach(({ name, role }) => {
        if (role && role.id && role.team !== "traveler") {
          if (!players[role.id]) {
            players[role.id] = [];
          }
          players[role.id].push(name);
        }
      });
      return players;
    },
    ...mapState(["roles", "modals", "edition", "grimoire", "jinxes"]),
    ...mapState("players", ["players"])
  },
  methods: {
    ...mapMutations(["toggleModal"])
  }
};
</script>

<style lang="scss" scoped>
@import "../../vars.scss";

.toggle {
  position: absolute;
  left: 20px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

.togglesecond {
  position: absolute;
  left: 50px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

h3 {
  margin: 0 40px;
  svg {
    vertical-align: middle;
  }
}

.townsfolk {
  .name {
    color: $townsfolk;
  }
  aside {
    background: linear-gradient(-90deg, $townsfolk, transparent);
  }
}
.outsider {
  .name {
    color: $outsider;
  }
  aside {
    background: linear-gradient(-90deg, $outsider, transparent);
  }
}
.minion {
  .name {
    color: $minion;
  }
  aside {
    background: linear-gradient(-90deg, $minion, transparent);
  }
}
.demon {
  .name {
    color: $demon;
  }
  aside {
    background: linear-gradient(-90deg, $demon, transparent);
  }
}

.jinxed {
  .name {
    color: $fabled;
  }
  aside {
    background: linear-gradient(-90deg, $fabled, transparent);
  }
}

.team {
  display: flex;
  align-items: stretch;
  width: 100%;
  &:not(:last-child):after {
    content: " ";
    display: block;
    width: 25%;
    height: 1px;
    background: linear-gradient(90deg, #ffffffaa, transparent);
    position: absolute;
    left: 0;
    bottom: 0;
  }
  aside {
    width: 30px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    text-shadow: 0 0 4px black;
  }

  h4 {
    text-transform: uppercase;
    text-align: center;
    transform: rotate(90deg);
    transform-origin: center;
    font-size: 80%;
  }

  &.jinxed {
    .icon {
      margin: 0 -5px;
    }
  }
}

ul {
  flex-grow: 1;
  display: flex;
  padding: 5px 0;

  li {
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: 420px;
    .icon {
      width: 8vh;
      background-size: cover;
      background-position: 0 -5px;
      flex-shrink: 0;
      flex-grow: 0;
      &:after {
        content: " ";
        display: block;
        padding-top: 75%;
      }
    }
    .role {
      line-height: 80%;
      flex-grow: 1;
    }
    .name {
      font-weight: bold;
      font-size: 75%;
      display: block;
    }
    .player {
      color: #888;
      float: right;
      font-size: 60%;
    }
    .ability {
      font-size: 70%;
    }
  }
}

/** break into 1 column below 1200px **/
@media screen and (max-width: 1199.98px) {
  .modal {
    max-width: 60%;
  }
  ul {
    li {
      .icon {
        width: 6vh;
      }
      .role {
        line-height: 100%;
      }
      .name {
        font-size: 100%;
      }
      .player {
        font-size: 100%;
      }
      .ability {
        font-size: 90%;
      }
    }
  }
}

/** trim icon size on maximized one-column sheet **/
@media screen and (max-width: 991.98px) {
  .rule .modal.maximized ul li .icon {
    width: 5.1vh;
  }
}

/** hide players when town square is set to "public" **/
#townsquare.public ~ .rule .modal .player {
  display: none;
}
</style>
